var map = {
	"./404.svg": 937,
	"./Categories.png": 938,
	"./Edit-menu.svg": 939,
	"./Egg.svg": 940,
	"./Emaier-Header.png": 941,
	"./Qr-4.png": 942,
	"./_duplicate.svg": 943,
	"./_overview.svg": 944,
	"./add-white.svg": 945,
	"./alert.svg": 946,
	"./all_category.svg": 947,
	"./archive.svg": 948,
	"./armchair.svg": 949,
	"./arrow-circle-right.svg": 950,
	"./arrow-left-circle.svg": 951,
	"./arrow-right-circle.svg": 952,
	"./arrow-right.svg": 351,
	"./asc-up-white.svg": 953,
	"./asc.png": 954,
	"./asc.svg": 955,
	"./back-arrow.svg": 956,
	"./barcode-icon.svg": 957,
	"./beverages.svg": 958,
	"./blue-edit-pen.svg": 959,
	"./blue-eye.svg": 960,
	"./box-office.svg": 961,
	"./broken-seat.jpg": 962,
	"./calendar_list.svg": 963,
	"./chevron-down.svg": 964,
	"./chevron-left.svg": 965,
	"./cinema-mamagement-sidebar.svg": 966,
	"./claendar.svg": 302,
	"./clock-1.svg": 967,
	"./clock.svg": 968,
	"./close-button.svg": 698,
	"./close-white.svg": 704,
	"./close-x.svg": 295,
	"./collapse-up.svg": 969,
	"./collapse.svg": 970,
	"./connection-lost.svg": 301,
	"./copy.svg": 971,
	"./copy_image_icon.png": 972,
	"./delete-red-light.svg": 973,
	"./delete-red.svg": 705,
	"./delete.svg": 683,
	"./deliver-icon.svg": 974,
	"./desc-down-white.svg": 975,
	"./desc.svg": 976,
	"./distributors-sidebar.svg": 977,
	"./download.svg": 978,
	"./dragndrop.svg": 979,
	"./dragndrop2.svg": 980,
	"./duplicate.svg": 981,
	"./duplicateScreen.svg": 982,
	"./e-wallet-icon-black.svg": 983,
	"./edit-pen-blue.svg": 984,
	"./edit-pen-white.svg": 985,
	"./edit-pen.svg": 986,
	"./edit.svg": 987,
	"./email.png": 988,
	"./empty-image.svg": 989,
	"./excel.svg": 990,
	"./external-link.svg": 991,
	"./eye.svg": 992,
	"./filter-icon.svg": 352,
	"./flag.svg": 993,
	"./fnb-beverages.svg": 994,
	"./fnb-brownie.svg": 995,
	"./fnb-combo.svg": 996,
	"./fnb-desert.svg": 997,
	"./fnb-eatables.svg": 998,
	"./fnb-make-your-combo.svg": 999,
	"./fnb-popcorn.svg": 1000,
	"./fnbtransactionIcon.svg": 1001,
	"./fullscreen-icon.svg": 706,
	"./funnel.svg": 1002,
	"./globe.svg": 1003,
	"./green-tick.svg": 1004,
	"./grid-view.svg": 1005,
	"./hide-password.svg": 353,
	"./home-icon.svg": 1006,
	"./home.svg": 1007,
	"./icon-black-play.svg": 1008,
	"./icon-dot.svg": 1009,
	"./icon-fnb.svg": 1010,
	"./icon-marketing.svg": 1011,
	"./icon-no-seat.png": 1012,
	"./icon-no-seat.svg": 1013,
	"./icon-option.svg": 1014,
	"./icon-poin-of-sale.svg": 1015,
	"./icon-recliner.svg": 1016,
	"./icon-report.svg": 1017,
	"./icon-sofa-dark-1.svg": 1018,
	"./icon-sofa-dark.png": 1019,
	"./icon-sofa-dark.svg": 1020,
	"./icon-sofa.svg": 1021,
	"./importfile.svg": 1022,
	"./info.svg": 700,
	"./info2.svg": 1023,
	"./keyboard-icon.svg": 1024,
	"./kitchen_display.svg": 1025,
	"./language-icon.svg": 296,
	"./left-caret.svg": 1026,
	"./link.svg": 1027,
	"./list-view.svg": 1028,
	"./loading.svg": 354,
	"./lock.svg": 1029,
	"./login-password.png": 355,
	"./login-user.png": 356,
	"./logout.svg": 707,
	"./masters-sidebar.svg": 1030,
	"./merchandise.svg": 1031,
	"./minus.svg": 1032,
	"./movie-pass-svg.svg": 687,
	"./movie-rolling.svg": 1033,
	"./mulitSchedule.svg": 1034,
	"./multicurrency.svg": 1035,
	"./multifnb.svg": 1036,
	"./nav-plus.svg": 1037,
	"./no-image.svg": 1038,
	"./no-schedule.svg": 131,
	"./non-veg-mark.png": 1039,
	"./non-veg-mark.svg": 1040,
	"./notification.svg": 1041,
	"./open-link-blue.svg": 1042,
	"./openPlanned.svg": 1043,
	"./overview.svg": 1044,
	"./overview2.svg": 1045,
	"./pdf-icon.svg": 1046,
	"./pdf.svg": 1047,
	"./pickup-ticket-icon.svg": 1048,
	"./pickupfnb.svg": 1049,
	"./play.svg": 1050,
	"./plus.svg": 1051,
	"./pointofsale-1.svg": 1052,
	"./pointofsale-2.svg": 1053,
	"./pointofsale.png": 1054,
	"./portfolio.svg": 1055,
	"./pos-fnb-no-itmes.svg": 694,
	"./pos-refresh.svg": 1056,
	"./primary/chevron-down.svg": 1057,
	"./primary/download.svg": 1058,
	"./primary/edit.svg": 1059,
	"./primary/filter.svg": 1060,
	"./primary/printer.svg": 1061,
	"./print-icon.svg": 1062,
	"./print.svg": 1063,
	"./question.svg": 1064,
	"./question1.svg": 1065,
	"./question2.svg": 708,
	"./question3.svg": 1066,
	"./recliner-1.svg": 1067,
	"./recliner.png": 1068,
	"./refund-icon.svg": 1069,
	"./reload-icon-pos.svg": 1070,
	"./reload-icon.svg": 1071,
	"./restore.svg": 1072,
	"./right-caret.svg": 1073,
	"./role-management-sidebar.svg": 1074,
	"./save.svg": 1075,
	"./schedule-icon.svg": 1076,
	"./school-calendar.svg": 1077,
	"./search-global-white.svg": 1078,
	"./search-global.svg": 1079,
	"./search.svg": 1080,
	"./searchIcon.svg": 1081,
	"./seat-icon-2.svg": 1082,
	"./seat-icon.svg": 1083,
	"./seat-icons/3-wheelChair.png": 1084,
	"./seat-icons/block_seat_new.png": 1085,
	"./seat-icons/broken-seat-1.svg": 1086,
	"./seat-icons/broken-seat-2.svg": 1087,
	"./select-food.png": 709,
	"./settings.svg": 1088,
	"./show-password.svg": 357,
	"./slider-triangle.svg": 1089,
	"./snack.svg": 710,
	"./sort.svg": 1090,
	"./star-empty.svg": 1091,
	"./star-fill.svg": 1092,
	"./statistics.svg": 1093,
	"./success-tick.svg": 1094,
	"./suitcase.svg": 1095,
	"./swap.svg": 1096,
	"./tick-green-item.svg": 711,
	"./tick-green.svg": 1097,
	"./ticket-icon.svg": 1098,
	"./trash.svg": 1099,
	"./unpaid-reservation.svg": 686,
	"./updown-white.svg": 1100,
	"./updown.svg": 1101,
	"./user-attribute.svg": 1102,
	"./user-attributes.svg": 1103,
	"./user-female.svg": 1104,
	"./user-male-white.svg": 1105,
	"./user-male.svg": 1106,
	"./user-profile.svg": 297,
	"./userProfile.png": 1107,
	"./veg-food-mark-white.png": 1108,
	"./veg-foog-mark-trans.png": 1109,
	"./view.png": 1110,
	"./view.svg": 1111
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 936;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 936
// module chunks = 34